import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { PRODUCTION_HOSTNAME } from '../../../utils/constants/integrationConstants';

// The marketing site links here about 2,948 times and `getSignupUrl` puts the
// originating page in `utm_source` on every one, so Google sees a hundred-odd
// variants of /signup and /login that differ only by query string. Search
// Console, 2026-09-07: 149 URLs under "Duplicate without user-selected
// canonical", 80 of them /signup and 56 /login. This selects the canonical it
// says nobody chose.
//
// The path only, never the query. That is the whole point: the parameter is
// what makes each URL look distinct, and dropping it from the canonical is what
// collapses them onto one page.
//
// The parameter itself must keep arriving intact, so do NOT be tempted into
// stripping it at the CDN or redirecting to the clean URL. The marketing site's
// BaseLayout reads `utm_source` off the query string to set FIRST touch in the
// `tt_attr` cookie, which this app reads at signup. A canonical is a hint to
// Google; the browser still gets the parameter.
//
// Always the production origin, whatever host is serving. From staging or a
// preview that consolidates onto production rather than competing with it.
const CANONICAL_ORIGIN = `https://${PRODUCTION_HOSTNAME}`;
const LINK_SELECTOR = 'link[rel="canonical"]';

export function CanonicalUrl() {
  const location = useLocation();

  useEffect(() => {
    let link = document.head.querySelector<HTMLLinkElement>(LINK_SELECTOR);

    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }

    link.href = `${CANONICAL_ORIGIN}${location.pathname}`;
  }, [location.pathname]);

  return null;
}
